<template>
  <div class="top5">
    <page-box :title="'园区贡献排行top5'">
      <div class="content">
        <div class="switch_box">
          <div
            :class="['item', selIndex == index ? 'active' : '']"
            v-for="(item, index) in switchData"
            :key="index"
            @click="selEcharts(index)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="echarts_content">
          <div class="icon_container">
            <div v-for="(item, index) in numberData" :key="index">
              <img :src="item" alt="" class="icon" />
            </div>
          </div>
          <my-echarts :options="overviewEcharts"></my-echarts>
        </div>
      </div>
    </page-box>
  </div>
</template>

<script setup>
import PageBox from '@/components/pageBox/PageBox';
import { ref, reactive, onMounted } from 'vue';
import MyEcharts from '@/baseCpm/MyEcharts/MyEcharts.vue';
import * as echarts from 'echarts';

const switchData = reactive([
  {
    name: '电',
    id: 0,
  },
  {
    name: '水',
    id: 1,
  },
]);
let selIndex = ref(0);
const selEcharts = (index) => {
  if (selIndex.value !== index) {
    selIndex.value = index;
    getoverviewEcharts();
  }
};

const numberData = ref([
  require('@/assets/images/Industry/first.png'),
  require('@/assets/images/Industry/second.png'),
  require('@/assets/images/Industry/third.png'),
  require('@/assets/images/Industry/fourth.png'),
  require('@/assets/images/Industry/fifth.png'),
]);

const overviewEcharts = ref(null);
const getoverviewEcharts = () => {
  let xAxisData = ['班组5', '班组4', '班组3', '班组2', '班组1'];
  let series = [
    {
      name: `${selIndex.value == 0 ? '产值' : '面积'}`,
      type: 'bar',
      data: [50, 70, 20, 59, 20],
      // 柱状图宽度
      barWidth: 8,
      // 柱状图柱子阴影
      showBackground: true,
      backgroundStyle: {
        color: 'rgba(180, 180, 180, 0.1)',
      },
      itemStyle: {
        color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [
          { offset: 1, color: 'rgba(24, 177, 254, 0.9)' },
          { offset: 0, color: '#18B1FE' },
        ]),
        // 柱状图修改圆形
        barBorderRadius: [0, 20, 20, 0],
      },
    },
  ];
  overviewEcharts.value = {
    grid: {
      top: '8%',
      left: '24%',
      right: '5%',
      bottom: '17%',
    },
    yAxis: {
      type: 'category',
      data: xAxisData,
      // boundaryGap: false,
      axisPointer: {
        type: 'shadow',
      },
      axisLabel: {
        margin: 9,
        fontSize: 14,
        lineHeight: 12,
        color: '#18B1FE',
        fontFamily: 'MiSans',
      },
      axisTick: {
        show: false,
      },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'line',
      },
      renderMode: 'html',
      backgroundColor: 'rgba(0, 0, 0, 0.2)',
      borderWidth: 0, // 提示框浮层的边框宽。
      padding: [6, 23],
      textStyle: {
        // 提示框浮层的文本样式。
        color: '#fff',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontFamily: 'OPPOSans,serif',
        fontSize: 14,
      },
    },
    xAxis: {
      name: `${selIndex.value == 0 ? '亿元' : '万㎡'}`,
      nameTextStyle: {
        fontFamily: 'MiSans',
        fontSize: 14,
        lineHeight: 14,
        color: 'rgba(24, 177, 254, 1)',
      },
      type: 'value',
      axisLabel: {
        formatter: '{value}',
        margin: 0,
        fontSize: 14,
        lineHeight: 12,
        color: '#18B1FE',
        fontFamily: 'MiSans',
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255,255,255,0)',
          width: 1,
        },
      },
    },
    series: series,
  };
};

onMounted(() => {
  getoverviewEcharts();
});
</script>

<style lang="scss" scoped>
.top5 {
  margin-bottom: 5px;
  .content {
    margin-left: 20px;
    // margin-top: 21px;
    width: 310px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .switch_box {
      padding-left: 28px;
      box-sizing: border-box;
      display: flex;
      width: 285.52px;
      height: 23.29px;
      background-size: 100% 100%;
      background-image: url(@/assets/images/Situation/switch_bg.png);
      .item {
        cursor: pointer;
        width: 77.76px;
        height: 23.29px;
        background-size: 100% 100%;
        background-image: none;
        text-align: center;
        color: #e4efff;
        font-family: MiSans;
        font-size: 12.66px;
        font-style: normal;
        font-weight: 400;
        line-height: 27.36px;
        letter-spacing: -0.288px;
        &.active {
          font-family: 'MiSansS';
          background-image: url(@/assets/images/Situation/active_bg.png);
        }
      }
    }

    .echarts_content {
      position: relative;
      width: 310.4px;
      height: 200px;
      .icon_container {
        position: absolute;
        height: 135px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        left: 8px;
        top: 24px;
        .icon {
          width: 18px;
          height: 18px;
        }
      }
    }
  }
}
</style>
